import React, { Component } from 'react'

class FormatCheckTextBox extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: this.props.value
    }
  }
  componentWillReceiveProps (nextProps) {
    this.setState({
      value: nextProps.value
    })
  }
  isError (text) {
    if (text.length === 0) return false
    const pattern = this.props.pattern
    if (!pattern) {
      return false
    }
    return !pattern.test(text)
  }
  getErrorMessageDisplayValue (text) {
    return this.isError(text) ? 'inherit' : 'none'
  }
  render () {
    return (
      <span>
        <input
          type={this.props.type}
          className={this.props.className}
          value={this.props.value}
          autoComplete={this.props.autoComplete}
          onChange={(e) => this.props.onChange(e, this.isError(e.target.value) || (e.target.value.trim().length === 0))}
          placeholder={this.props.placeholder}
          />
        <span style={{display: this.getErrorMessageDisplayValue(this.state.value)}}>
          <div className='kw-alert'>
            {this.props.message}
          </div>
        </span>
      </span>
    )
  }
}
FormatCheckTextBox.defaultProps = {type: 'text', placeholder: '', pattern: '', className: '', value: '', message: '', autoComplete: '', onChange: (e) => {}}
export default FormatCheckTextBox



// WEBPACK FOOTER //
// ./src/common/component/FormatCheckTextBox.js